import { useEffect, useState } from "react";
import "../../assets/css/certificate.css";

const CertificatePreview = ({
  title,
  line1,
  line2,
  logos = [],
  issuers = [],
  bg,
  recipientName = `[Recipient Name]`,
  courseName = `[Course Name]`,
}) => {
  const [certLogos, setCertLogos] = useState([]);
  const [certIssuers, setCertIssuers] = useState([]);

  useEffect(() => {
    const processLogos = async () => {
      const tempLogos = await Promise.all(
        logos.map((logo) => {
          if (typeof logo == "object") {
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve(reader.result);
              };
              reader.readAsDataURL(logo);
            });
          } else {
            return Promise.resolve(logo);
          }
        }),
      );
      setCertLogos(tempLogos);
    };
    processLogos();
  }, [logos]);

  useEffect(() => {
    const processIssuers = async () => {
      const tempIssuers = await Promise.all(
        issuers.map((issuer) => {
          if (typeof issuer.signatureImage == "object") {
            return new Promise((resolve) => {
              const reader = new FileReader();
              reader.onloadend = () => {
                resolve({
                  name: issuer.name,
                  designation: issuer.designation,
                  image: reader.result,
                });
              };
              reader.readAsDataURL(issuer.signatureImage);
            });
          } else {
            return Promise.resolve({
              name: issuer.name,
              designation: issuer.designation,
              image: issuer.signatureImage,
            });
          }
        }),
      );
      setCertIssuers(tempIssuers);
    };

    processIssuers();
  }, [issuers]);

  return (
    <div class="certificate-wrapper">
      {bg ? <img src={bg} class="bg-image" /> : null}

      <div class="certificate-header">
        {certLogos.map((logo, index) => (
          <img src={logo} key={index} class="logo" />
        ))}
      </div>

      <div class="certificate-body">
        <div class="certificate-title">{title}</div>
        <div class="line-1">{line1}</div>
        <div class="recipient-name">{recipientName}</div>
        <div class="line-2">{line2}</div>
        <div class="received-in">{courseName}</div>
        <div class="completion-date">
          <b>Date of Completion: </b> <span style={{ visibility: "hidden" }}>{new Date().toLocaleDateString()}</span>
        </div>
      </div>

      <div class="certificate-footer">
        {certIssuers.map((issuer) => (
          <div class="issuer">
            <img src={issuer.image} />
            <hr class="issuer-sign" />
            <div class="issuer-name">{issuer.name}</div>
            <div class="issuer-designation">{issuer.designation}</div>
          </div>
        ))}
      </div>

      <div class="qr-code">
        QR
        <span />
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

export default CertificatePreview;
